<template>
    <ul class="mstar">
        <template v-for="(item, index) in stars">
            <li class="star" :key="index">
                <img class="img" :src="score > index ? selectedSrc : normalSrc"></img>
                <i class="star-a" @click="getScore(item)"></i>
            </li>
        </template>
    </ul>
</template>

<script>
    export default {
        name: "MStar",
        data() {
            return {
                stars: 5,
                normalSrc: require("@/assets/stara.png"),
                selectedSrc: require("@/assets/starb.png"),
                score: 0
            }
        },
        methods: {
            getScore(score) {
                let _score = score;
                if (this.score == 1 && score == 1) {
                    _score = 0; // 只有一颗星的时候,再次点击,变为0颗
                };
                this.score = _score;
                this.$emit("getScore", _score);
            }
        }
    };
</script>

<style scoped lang="scss">
    .mstar{
        display: flex;
        flex-direction: row;
    }
    .star{
        position: relative;
    }

    .img {
        width: 30px;
        height: 30px;
        display: block;
    }
    .star-a {
        width: 30px;
        height: 30px;
        position: absolute;
        top: 0px;
        left: 0px;
        z-index: 1;
    }
</style>
